import type { ApolloError } from '@apollo/client';
import { SubmitQSetReviewErrorCode } from '@exam-management/graphql';

export const TASK_OVERDUE_ERROR_CODE: string = SubmitQSetReviewErrorCode.TaskOverdue;

type Details = { code?: string } | { code?: string }[] | undefined;

function detailsHaveCode(details: Details, code: string): boolean {
  if (!details) {
    return false;
  }
  return Array.isArray(details) ? details.some((d) => d?.code === code) : details.code === code;
}

function extensionsHaveCode(
  extensions: Record<string, unknown> | undefined,
  code: string,
): boolean {
  if (!extensions) {
    return false;
  }
  if (extensions.code === code) {
    return true;
  }
  if (detailsHaveCode(extensions.details as Details, code)) {
    return true;
  }
  const response = extensions.response as
    | { body?: { errors?: { extensions?: { code?: string; details?: Details } }[] } }
    | undefined;
  return (
    response?.body?.errors?.some(
      (err) => err.extensions?.code === code || detailsHaveCode(err.extensions?.details, code),
    ) ?? false
  );
}

export function isTaskOverdueError(error: ApolloError): boolean {
  return error.graphQLErrors.some((err) =>
    extensionsHaveCode(
      err.extensions as Record<string, unknown> | undefined,
      TASK_OVERDUE_ERROR_CODE,
    ),
  );
}
